import { render, staticRenderFns } from "./TSLChanges.vue?vue&type=template&id=7084f3ba&scoped=true&"
import script from "./TSLChanges.vue?vue&type=script&lang=js&"
export * from "./TSLChanges.vue?vue&type=script&lang=js&"
import style0 from "./TSLChanges.vue?vue&type=style&index=0&id=7084f3ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7084f3ba",
  null
  
)

export default component.exports